var modules_3d2af0d9 = {"popup":"_9bv1di","header":"_3ui2jo"};
import "../../../assets/53jypn9i.css";

export { modules_3d2af0d9 as default };
//# sourceMappingURL=auth-popup.module.scss.js.map
